__turbopack_context__.v({
  "__horizontalScroll": "SliderLocation-module-scss-module___uxgIa____horizontalScroll",
  "buttonContainer": "SliderLocation-module-scss-module___uxgIa__buttonContainer",
  "buttonWrapperNext": "SliderLocation-module-scss-module___uxgIa__buttonWrapperNext",
  "buttonWrapperPrev": "SliderLocation-module-scss-module___uxgIa__buttonWrapperPrev",
  "horizontalScrollContainer": "SliderLocation-module-scss-module___uxgIa__horizontalScrollContainer",
  "horizontalScrollImg": "SliderLocation-module-scss-module___uxgIa__horizontalScrollImg",
  "horizontalScrollImgGradient": "SliderLocation-module-scss-module___uxgIa__horizontalScrollImgGradient",
  "horizontalScrollImgTitle": "SliderLocation-module-scss-module___uxgIa__horizontalScrollImgTitle",
  "horizontalScrollItem": "SliderLocation-module-scss-module___uxgIa__horizontalScrollItem",
  "horizontalScrollWrapper": "SliderLocation-module-scss-module___uxgIa__horizontalScrollWrapper",
  "itemInner": "SliderLocation-module-scss-module___uxgIa__itemInner",
  "swiperButtonIconNext": "SliderLocation-module-scss-module___uxgIa__swiperButtonIconNext",
  "swiperButtonIconPrev": "SliderLocation-module-scss-module___uxgIa__swiperButtonIconPrev",
  "swiperButtonNext": "SliderLocation-module-scss-module___uxgIa__swiperButtonNext",
  "swiperButtonPrev": "SliderLocation-module-scss-module___uxgIa__swiperButtonPrev",
});
